(() => {
  if (window.KnaonProductReviewScroll) return;
  window.KnaonProductReviewScroll = true;

  const triggerSelector = [
    '.main-product-section .product-detail__information .jdgm-preview-badge',
    '.main-product-section .product-detail__information .product-reviews',
    '.main-product-section .product-detail__information review-product'
  ].join(',');

  function findReviewPanel() {
    const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    return document.getElementById('reviews') || widget?.closest('.tab-panel') || widget;
  }

  function activateReviewPanel(panel) {
    if (!panel?.classList.contains('tab-panel') || panel.classList.contains('active')) return;

    const section = panel.closest('.shopify-section, section') || document;
    const button = section.querySelector(
      '[data-tab="reviews"], [aria-controls="reviews"], a[href="#reviews"]'
    );

    if (button) {
      button.click();
      return;
    }

    panel.parentElement?.querySelectorAll(':scope > .tab-panel.active').forEach((sibling) => {
      sibling.classList.remove('active');
    });
    panel.classList.add('active');
  }

  function getHeaderOffset() {
    const header = document.querySelector(
      'sticky-header, .section-header, #shopify-section-header, header[role="banner"]'
    );
    const height = header?.getBoundingClientRect().height || 0;
    return Math.max(height, window.innerWidth < 768 ? 64 : 76) + 12;
  }

  function scrollToReviews() {
    const panel = findReviewPanel();
    if (!panel) return;

    activateReviewPanel(panel);
    window.setTimeout(() => {
      const top = panel.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }, 60);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(triggerSelector);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToReviews();
  }, true);
})();
